import Quill from 'quill';
import Vue from 'vue';
import CustomColor from '@groovepages/gd-ui-kit/components/ColorPickerMenu';
import i18n from '../../plugins/i18n';
import CustomBubbleTooltip from './quill-custom-tooltip';
import { QuillToolbarButton } from './quill-toolbar-helper';

const Parchment = Quill.import('parchment');
const BlockEmbedHtml = Quill.import('blots/block/embed');
const ImageBlot = Quill.import('formats/image');

let changeToolbarQlFormatsEl = null;
const initializeCustomQuillTooltip = (quill) => {
  const customTooltip = new CustomBubbleTooltip(quill);
  const div = document.createElement('div');
  div.classList.add('ql-toolbar');
  div.classList.add('ql-toolbar-embed');

  customTooltip.root.appendChild(div);

  // Edit Button
  const editButton = new QuillToolbarButton({
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.--><path d="M362.7 19.32c25-24.998 65.6-24.998 90.6 0l39.4 39.43c25 24.99 25 65.55 0 90.55l-48.4 48.4-130-129.98 48.4-48.4zm59 200.98L188.5 453.4c-10.4 10.4-23.3 18.1-37.4 22.2L30.77 511c-8.42 2.5-17.53.2-23.74-6.9-6.21-5.3-8.532-14.4-6.054-22.9L36.37 360.9c4.16-14.1 11.79-27 22.2-37.4L291.7 90.34l130 129.96z"/></svg>`
  });
  editButton.onClick = (quill) => {
    const range = quill.getSelection();
    const content = quill.getContents(range.index, range.length);
    quill.setSelection(range.index, 0, 'silent');

    if(content.ops[0].insert.image){
      quill.container.parentNode.__vue__.$parent.$refs.editImageModal.open();
    }

    if(content.ops[0].insert.addVideo){
      quill.container.parentNode.__vue__.$parent.$refs.videoPicker.$refs['video-picker-modal'].open();
    }

    if(content.ops[0].insert.embedElement){
      quill.container.parentNode.__vue__.$parent.$refs.embedModal.open();
      quill.container.parentNode.__vue__.$parent.embedCode = content.ops[0].insert.embedElement.value;
      quill.container.parentNode.__vue__.$parent.embedEdit = true;
    }
  };
  editButton.attach(quill, customTooltip);

  const toolbarButton = new QuillToolbarButton({
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"/></svg>`
  });

  changeToolbarQlFormatsEl = toolbarButton.qlFormatsEl;

  toolbarButton.onClick = (quill) => {
    const range = quill.getSelection();
    quill.setSelection(range.index, 0, 'user');
    quill.setSelection(range.index, 1, 'user');
  };

  // line above
  const addLineAboveButton = new QuillToolbarButton({
    icon: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M5 15h4v6h6v-6h4l-7-8zM4 3h16v2H4z"/></svg>`
  });
  addLineAboveButton.onClick = function(quill) {
      const range = quill.getSelection();
      quill.insertText(range.index, '\n', true);
      quill.setSelection(range.index, 0);
  };
  addLineAboveButton.attach(quill, customTooltip);

  // line bellow
  const addLineBellowButton = new QuillToolbarButton({
    icon: `<svg style="transform: rotate(180deg)" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M5 15h4v6h6v-6h4l-7-8zM4 3h16v2H4z"/></svg>`
  });
  addLineBellowButton.onClick = function(quill) {
      const range = quill.getSelection();

      const selection = quill.selection.getRange()[1];
      let newRange = 1;
      if(selection.start.node instanceof Image){
        newRange = 2;
      }
      quill.insertText(range.index + 1, '\n', 'user');
      quill.setSelection(range.index + newRange, 0);
  };
  addLineBellowButton.attach(quill, customTooltip);

  // Trash
  const trashButton = new QuillToolbarButton({
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.--><path d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0h120.4c12.1 0 23.2 6.848 28.6 17.69L320 32h96c17.7 0 32 14.33 32 32s-14.3 32-32 32H32C14.33 96 0 81.67 0 64s14.33-32 32-32h96l7.2-14.31zM31.1 128H416v320c0 35.3-28.7 64-64 64H95.1c-34.45 0-64-28.7-64-64V128zm80 80v224c0 8.8 8.1 16 16 16 9.7 0 16-7.2 16-16V208c0-8.8-6.3-16-16-16-7.9 0-16 7.2-16 16zm96 0v224c0 8.8 8.1 16 16 16 9.7 0 16.9-7.2 16.9-16V208c0-8.8-7.2-16-16.9-16-7.9 0-16 7.2-16 16zm96.9 0v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16s-16 7.2-16 16z"/></svg>`
  });
  trashButton.onClick = function(quill) {
      const range = quill.getSelection();
      quill.deleteText(range);
  };
  toolbarButton.attach(quill, customTooltip);
  trashButton.attach(quill, customTooltip);

  return customTooltip;
};

function trickClickIframe(evt){
  changeToolbarQlFormatsEl.style.display = 'none';
  evt.preventDefault();
  evt.stopPropagation();
  evt.stopImmediatePropagation();
  const closestQuillContainer = document.activeElement.closest('.ql-container');
  if(!closestQuillContainer){
    return;
  }
  window.focus();
  const quill = closestQuillContainer.__quill;
  if(!quill){
    return;
  }
  window.setTimeout(() => {
    const range = quill.getSelection();
    let p = Parchment.find(document.activeElement);

    if(!p){
      p = Parchment.find(document.activeElement.closest('.video-iframe-wrapper'));
    }
    if (p instanceof BlockEmbedHtml) {
      const off = p.offset(quill.scroll);
      if(!range){
        setTimeout(() => {
          quill.focus();
        });
      }
      quill.setSelection(off, 0, 'silent');
      quill.setSelection(off, 1, 'silent');
    }
  }, 0);
}

export const vueQuillInit = (quill) => {
  const {tooltip} = quill.theme;
  tooltip.root.style.zIndex=2;

  const input = tooltip.root.querySelector('input[data-link]');
  input.dataset.link = 'https://groove.cm';
};

export const theBlockBlot = (quill, vueInst) =>{
  setTimeout(() => {
    const Block = Quill.import('blots/block');
    const range = quill.getSelection(true);
    if (range == null) return;
    if (range.length == 0) {
      const [block, offset] = quill.scroll.descendant(Block, range.index);
      if (
        block != null &&
        block.domNode.innerText.trim().length === 0
      ) {
        vueInst.showToolbar = true;
        const lineBounds = quill.getBounds(range);
        vueInst.topPosition = lineBounds.top - 5;
      } else {
        vueInst.showToolbar = false;
      }
    }
  }, 300);
};

export const quillToolbar = [
	['bold', 'italic', 'underline', 'strike'],
	[{ list: 'ordered' }, { list: 'bullet' }],
	[{ color: [] }, { background: [] }],
	['link'],
];
